import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { ContentsItem } from '../../../modules/editor/types';

import { RootState } from '../../../modules';

type Props = {
	contentItem: ContentsItem
};

function Htmlcode({ contentItem }: Props) {

	const [showToolbar, setShowToolbar] = useState(false);	

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);

	useEffect(() => {
		if (selectedContentId !== contentItem.id) {
			unselectContent();
		}
	}, [selectedContentId]);

	const startEditing = () => {
		setShowToolbar(true);
	}

	const unselectContent = () => {
		setShowToolbar(false);
	}
	
	return (
		<div className={showToolbar ? 'htmlcode-edit active' : 'htmlcode-edit'}>
			<div className="htmlcode-edit-content">
				<div dangerouslySetInnerHTML={{ __html: contentItem?.content?.content[0]?.text }}></div>
				{
					!showToolbar && (
						<div
							className="cover"
							onClick={startEditing}
						>
						</div>
					)
				}
			</div>
		</div>
	);
}

Htmlcode.defaultProps = {};

export default Htmlcode;
